interface PeriodPresetValue {
  label: string;
  range: () => { from: Date; to: Date };
}

const startOfDay = (d: Date) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

export enum PeriodPreset {
  LastSevenDays = "last-seven-days",
  CurrentMonth = "current-month",
  LastMonth = "last-month",
}

/**
 * Date-range presets requested on the dashboard.
 */
export const PERIOD_PRESETS: Record<PeriodPreset, PeriodPresetValue> = {
  [PeriodPreset.LastSevenDays]: {
    label: "7 derniers jours",
    range: () => {
      const to = new Date();
      const from = startOfDay(new Date(to.getTime() - 6 * 24 * 3600 * 1000));
      return { from, to };
    },
  },
  [PeriodPreset.CurrentMonth]: {
    label: "Mois en cours",
    range: () => {
      const to = new Date();
      const from = new Date(to.getFullYear(), to.getMonth(), 1);
      return { from, to };
    },
  },
  [PeriodPreset.LastMonth]: {
    label: "Mois dernier",
    range: () => {
      const now = new Date();
      const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const to = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59);
      return { from, to };
    },
  },
};
